const initialState = {};

const getters = {
  firstPlay: () => (game) => {
    const played = localStorage.getItem(`played_${game}`);
    return !played;
  },
};

const actions = {
  firstPlay(ops, game) {
    localStorage.setItem(`played_${game}`, new Date());
  },
};

const mutations = {};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
